import React from "react"

export default function Message2() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M4.18213 5.12891H19.9321C20.5531 5.12891 21.0571 5.63291 21.0571 6.25391V17.5039C21.0571 18.1249 20.5531 18.6289 19.9321 18.6289H15.4384C14.7007 18.6289 13.9796 18.8472 13.3659 19.2564L9.99607 21.5029C8.95355 22.198 7.55713 21.4506 7.55713 20.1977C7.55713 19.3313 6.85477 18.6289 5.98837 18.6289H4.18213C3.56113 18.6289 3.05713 18.1249 3.05713 17.5039V6.25391C3.05713 5.63291 3.56113 5.12891 4.18213 5.12891Z" fill="white" />
      </svg>
   )
}
